// extracted by mini-css-extract-plugin
export default {"weChat":"index_weChat__E62Tm","icon":"index_icon__l-zy3"};